module.exports = __webpack_public_path__ + "img/slide1.1ba5427e.webp";